import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This previously renovated federation home had a generous garden area that required attention. With a brief to bring the garden up to date but still reference the traditional features / architecture a soft natural material palette of sandstone brick retaining with large format tiling was applied. Lush perimeter planting provides the structure and the necessary privacy while the layers of more traditional planting such as Buxus, Lavender and native violet further enhance the formal style and reference the traditional period of the home.',
            'Bougainvillea has been used to frame the lower terrace level and Juniperus and pencil pines used around the pool to add Mediterranean accents. The result is a relaxed and inviting space that the family uses year round.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Architecture
          <br />Construction
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          <br />Classic
          </p>
        ),
        image : '../images/projects/haberfield2-1.jpg',
        title : 'Haberfield Traditional'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/haberfield2-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/haberfield2-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/haberfield2-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/haberfield2-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/haberfield2-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/haberfield2-6.jpg'
    },
]

const PageHaberfieldTraditional = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageHaberfieldTraditional